module.exports = __webpack_public_path__ + "img/3.65b1274f.png";